export default "__VITE_ASSET__06ee0419__"